import styled from 'styled-components';
import { Layout } from 'antd';

const { Sider, Content } = Layout;

export const SiderWrapper = styled(Sider)`
  background-color: whitesmoke !important;
  text-align: left;
  min-width: 280px !important;
  max-width: 280px !important;
`;

export const SiderHeader = styled.div`
  background-color: #f8f8f8;
`;

export const SiderContent = styled(Content)`
  height: 100%;
  overflow-y: auto;
`;

export const SiderLayout = styled(Layout)`
  height: 100%;
`;
